import { Box, Stack, Typography } from "@mui/material";
import { differenceInYears } from "date-fns";
import { useMemo } from "react";
import MasonryLayout from "src/components/MasonryLayout";
import MasonryColumnsSelector from "src/components/MasonryLayout/components/MasonryColumnsSelector";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";
import UserInfo from "src/pages/Employee/components/UserInfo";

const MyAccount = () => {
  const clinician = useClinician((s) => s);

  const employeeInfo = useMemo(() => {
    const age = differenceInYears(new Date(), new Date(clinician?.dob || ""));

    return `${clinician?.first_name} ${clinician?.last_name}, ${age || null}, ${
      clinician?.gender
    }`;
  }, [clinician]);

  return (
    <Stack width="100%" gap={2}>
      <Stack direction="row" gap={2}>
        <Typography variant="h4">{employeeInfo}</Typography>
        <Box ml="auto">
          <MasonryColumnsSelector />
        </Box>
      </Stack>

      <MasonryLayout spacing={1}>
        <UserInfo user={clinician} includePassword={true} />
      </MasonryLayout>
    </Stack>
  );
};

export default MyAccount;
